import { CrudFilters } from "@refinedev/core";
import { mapOperator } from "./mapOperator";

export const generateFilter = (filters?: CrudFilters) => {
  const queryFilters: { [key: string]: string } = {};

  if (filters) {
    filters.map((filter) => {
      if (filter.operator === "or" || filter.operator === "and") {
        throw new Error(
          `[@refinedev/simple-rest]: \`operator: ${filter.operator}\` is not supported. You can create custom data provider. https://refine.dev/docs/api-reference/core/providers/data-provider/#creating-a-data-provider`
        );
      }

      if ("field" in filter) {
        const { field, operator, value } = filter;

        if (field === "q") {
          queryFilters[field] = value;
          return;
        }

        const mappedOperator = mapOperator(operator);
        queryFilters[`${field}${mappedOperator}`] = value;
      }
    });
  }

  return queryFilters;
};

export function updateFilters(filters: any, field: string, operator: string, value: string) {
  var newFilter = filters.filter((filter: any) => filter.field !== field);

  if (value !== "" && value !== null && value !== undefined) 
    newFilter.push({
      field: field,
      value: value,
      operator: operator,
    });

  return newFilter;
}

// type="date" 입력값이 필터로 사용해도 되는 상태인지 확인한다.
// 빈 값(필터 해제)이거나, 완전한 YYYY-MM-DD 형식이면서 연도가 상식적인 범위일 때만 true.
// 날짜를 한 글자씩 입력/수정하는 도중 만들어지는 잘못된 부분 날짜(예: 0002-02-04, 122520-02-04)로
// 매 키 입력마다 필터가 걸려 불필요한 요청이 나가는 것을 막기 위함.
export function isCompleteDateString(value: string): boolean {
  if (value === "") return true;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const year = Number(value.slice(0, 4));
  return year >= 1900 && year <= 2100;
}